module.exports = __webpack_public_path__ + "img/download-2-2INT.85a5a558.png";